var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:{'dark-theme': _vm.header && _vm.header.theme && _vm.header.theme === 'dark' }},[(_vm.header)?_c('st-header',{attrs:{"header":_vm.header}}):_vm._e(),(_vm.isReuters)?_c('reuters'):_vm._e(),_c('st-article')],1)}
var staticRenderFns = []

export { render, staticRenderFns }